export default "__VITE_ASSET__Dk9Oh3MW__"